import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
  class: "done"
};
const _hoisted_2 = ["innerHTML"];

const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" Nous avons bien pris en compte votre demande."), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" Vous serez contacté rapidement par un de nos agent. ")], -1);

const _hoisted_4 = ["innerHTML"];

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "done"
}, [/*#__PURE__*/_createElementVNode("h2", null, "Erreur"), /*#__PURE__*/_createElementVNode("p", {
  style: {
    "width": "100",
    "text-align": "center"
  }
}, " Ce lien est invalide. ")], -1);

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "done"
}, [/*#__PURE__*/_createElementVNode("h2", null, "Envoi en cours"), /*#__PURE__*/_createElementVNode("p", {
  style: {
    "width": "100",
    "text-align": "center"
  }
}, " Merci de bien vouloir patienter... ")], -1);

const _hoisted_7 = {
  id: "contact",
  class: "long-break contact-wrapper"
};
const _hoisted_8 = {
  class: "ctc"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  class: "contact"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  class: "form-item"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  class: "form-item"
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Prénom", -1);

const _hoisted_16 = {
  class: "form-item"
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  class: "form-item"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", null, "Séléctionnez un type de demande", -1);

const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", null, "Problème technique lors de ma participation", -1);

const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", null, " Le site pour participer à l'opération ne fonctionne pas ", -1);

const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", null, " Je n'arrive pas à suivre le statut de ma participation sur la page dédiée ", -1);

const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 2
};

const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", null, " Je n'ai pas reçu l'email de confirmation de ma participation ", -1);

const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", null, " Question générale à propos de l'opération ", -1);

const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", null, " Je ne comprends pas pourquoi ma participation est invalide ", -1);

const _hoisted_29 = {
  key: 3
};
const _hoisted_30 = {
  class: "form-item"
};
const _hoisted_31 = ["innerHTML"];
const _hoisted_32 = {
  class: "form-item message"
};
const _hoisted_33 = ["innerHTML"];

const _hoisted_34 = /*#__PURE__*/_createTextVNode();

const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn-wrapper"
}, [/*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Envoyer"
})], -1);

const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  class: "promodev",
  src: "/images/contact-logo.png"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_GDialog = _resolveComponent("GDialog");

  const _component_Field = _resolveComponent("Field");

  const _component_Form = _resolveComponent("Form");

  return _openBlock(), _createElementBlock("main", null, [_createVNode(_component_GDialog, {
    modelValue: _ctx.dialogState,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.dialogState = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h2", {
      innerHTML: _ctx.$CD('CONTACT_SEND_TITLE')
    }, null, 8, _hoisted_2), _hoisted_3, _createElementVNode("div", null, [_createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = (...args) => $options.reloadform && $options.reloadform(...args)),
      innerHTML: _ctx.$CD('CONTACT_SEND_BUTTON')
    }, null, 8, _hoisted_4)])])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_GDialog, {
    persistent: "",
    modelValue: _ctx.errorState,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.errorState = $event)
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_GDialog, {
    persistent: "",
    modelValue: _ctx.loadingState,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.loadingState = $event)
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h2", {
    innerHTML: _ctx.$CD('CONTACT_TITLE')
  }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_ctx.operation ? (_openBlock(), _createElementBlock("h3", _hoisted_11, "Opération : " + _toDisplayString(_ctx.operation.title), 1)) : _createCommentVNode("", true), _createVNode(_component_Form, {
    onSubmit: $options.onSubmit
  }, {
    default: _withCtx(({
      errors
    }) => [_createElementVNode("div", _hoisted_12, [_createElementVNode("label", {
      innerHTML: _ctx.$CD('CONTACT_FIELD_NOM')
    }, null, 8, _hoisted_13), _createVNode(_component_Field, {
      name: "nom",
      rules: $options.isRequired
    }, null, 8, ["rules"]), _createElementVNode("span", null, _toDisplayString(errors.nom), 1)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createVNode(_component_Field, {
      name: "prenom",
      rules: $options.isRequired
    }, null, 8, ["rules"]), _createElementVNode("span", null, _toDisplayString(errors.prenom), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("label", {
      innerHTML: _ctx.$CD('CONTACT_FIELD_EMAIL')
    }, null, 8, _hoisted_17), _createVNode(_component_Field, {
      name: "email",
      rules: $options.validateEmail
    }, null, 8, ["rules"]), _createElementVNode("span", null, _toDisplayString(errors.email), 1)]), _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.form.demande = $event)
    }, [_hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, _ctx.opid != '64c76fe9763f8dffbcbd9a7e' ? (_openBlock(), _createElementBlock("option", _hoisted_23, "Je n'ai pas reçu mon lot")) : _createCommentVNode("", true), _ctx.opid != '64c76fe9763f8dffbcbd9a7e' ? (_openBlock(), _createElementBlock("option", _hoisted_24, "Je n'ai pas reçu le virement bancaire")) : _createCommentVNode("", true), _ctx.opid != '64c76fe9763f8dffbcbd9a7e' ? (_openBlock(), _createElementBlock("option", _hoisted_25, " Le montant du virement bancaire reçu n'est pas le bon ")) : _createCommentVNode("", true), _hoisted_26, _hoisted_27, _hoisted_28, _ctx.opid != '64c76fe9763f8dffbcbd9a7e' ? (_openBlock(), _createElementBlock("option", _hoisted_29, " Question à propos du produit acheté ")) : _createCommentVNode("", true)], 512), [[_vModelSelect, _ctx.form.demande]])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("label", {
      innerHTML: _ctx.$CD('CONTACT_FIELD_OBJET')
    }, null, 8, _hoisted_31), _createVNode(_component_Field, {
      name: "objet",
      rules: $options.isRequired
    }, null, 8, ["rules"]), _createElementVNode("span", null, _toDisplayString(errors.objet), 1)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("label", {
      innerHTML: _ctx.$CD('CONTACT_FIELD_MESSAGE')
    }, null, 8, _hoisted_33), _hoisted_34, _hoisted_35, _withDirectives(_createElementVNode("textarea", {
      name: "message",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.form.message = $event)
    }, null, 512), [[_vModelText, _ctx.form.message]]), _createElementVNode("span", null, _toDisplayString(errors.message), 1)]), _hoisted_36, _hoisted_37]),
    _: 1
  }, 8, ["onSubmit"])])])])]);
}